/**
 * Compile-time exhaustiveness check for union types.
 * Call after handling every member of a union (e.g. in a switch `default`).
 * If a member is left unhandled, `value` is not `never` and TypeScript errors at the call site - code will not 'compile'
 * At runtime it throws, guarding against values that bypass the type system (e.g. from plain JS callers).
 */
export function assertAllUnionMembersHandled(value: never): never {
  throw new Error(`Unhandled union member: ${String(value)}`);
}
